import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const FeaturesNumberedCardsContainer = ({ numberedCards }) => {
  return (
    <div className="mx-auto mt-6 mb-6 w-[90vw] px-4 xl:w-(--container-width) xl:px-0">
      <div className="mt-12 flex flex-wrap items-stretch justify-center gap-y-6">
        {(numberedCards || []).map((card, index) => (
          <VisibleLoading key={card.id} delay={index * 100}>
            {({ ref, className }) => (
              <FeaturesNumberedCard innerRef={ref} className={className} key={card.id} card={card} index={index} />
            )}
          </VisibleLoading>
        ))}
      </div>
    </div>
  );
};
export default FeaturesNumberedCardsContainer;

const FeaturesNumberedCard = ({ innerRef, className, card, index }) => {
  return (
    <div ref={innerRef} className={`basis-full xl:min-h-[200px] xl:basis-1/3 xl:px-2 ${className || ''}`.trim()}>
      <div className="flex h-full flex-col justify-between gap-y-10 rounded-2xl border border-white/20 p-6 xl:gap-y-0">
        <div className={`text-brand-400 text-2xl font-medium`}>{index + 1 < 10 ? `0${index + 1}` : index + 1}</div>

        <h3 className="heading-6">{card.label}</h3>
      </div>
    </div>
  );
};
